import { useCallback, useEffect, useState } from 'react'
import settings from '../../components/settings'

const LocalStorageKey = 'create-online-meeting'
// eslint-disable-next-line no-underscore-dangle
const omni = window.__OMNI__ || {};

export const useOnlineMeeting = ({ appointmentId, updated }) => {
  const [meeting, setMeeting] = useState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  const getMeeting = useCallback(async () => {
    setLoading(true)
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`
    )
    const data = response.status === 200 ? await response.json() : null
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting(data || {})
      setError(undefined)
    } else {
      setMeeting({})
      setError(err)
    }
    setLoading(false)
    return { success, data, error: err }
  }, [appointmentId])

  const getToken = useCallback(() => {
    const roles = omni.payload?.['https://nobiadigital.com/roles'];
    if (Array.isArray(roles) && roles.includes('staff') && omni.access_token) {
      return omni.access_token
    }
    // if inside iframe already dont do anything
    if (window.self !== window.top) {
      return null
    }

    window.localStorage.setItem(LocalStorageKey, appointmentId)
    window.location.replace(`/sales-tool/appointments/${appointmentId}`)

    return null;
  }, [appointmentId])

  const createMeeting = useCallback(async () => {
    setLoading(true)
    const token = getToken()
    if (!token) {
      return {};
    }
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const data = response.ok && (await response.json())
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting(data)
      setError(undefined)
    } else {
      setMeeting({})
      setError(err)
    }
    setLoading(false)
    return { success, data, error: err }
  }, [getToken, appointmentId])

  const deleteMeeting = useCallback(async () => {
    setLoading(true)
    const token = getToken()
    if (!token) {
      return {};
    }
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting({})
    }
    setLoading(false)
    return { success, error: err }
  }, [getToken, appointmentId])

  useEffect(() => {
    setMeeting(null)
  }, [updated])

  useEffect(() => {
    if (meeting || loading) {
      return
    }
    const id = window.localStorage.getItem(LocalStorageKey)
    if (id === appointmentId && omni.access_token) {
      window.localStorage.removeItem(LocalStorageKey)
      createMeeting()
    } else {
      getMeeting()
    }
  }, [createMeeting, getMeeting, getToken, meeting, loading, appointmentId])

  return { createMeeting, deleteMeeting, meeting, error, loading }
}
